import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Linkify } from '@/components/Linkify/Linkify';
import { isArabic } from '@/config/constants';
import { useMarkdownToHtml } from '@/hooks/useMarkdownToHtml';
const ANIMATION_DURATION_MS = 500;
export const Text = ({ message, event, showAnimation }) => {
    var _a;
    const text = message ? message.text : ((_a = event.body) === null || _a === void 0 ? void 0 : _a.text) || event.text || '';
    const { html } = useMarkdownToHtml(text);
    const [displayedText, setDisplayedText] = useState('');
    useEffect(() => {
        let i = 0;
        let isTag = false;
        let currentText = '';
        function type() {
            if (i >= html.length) {
                return;
            }
            currentText += html[i];
            if (html[i] === '<')
                isTag = true;
            if (html[i] === '>')
                isTag = false;
            setDisplayedText(currentText);
            i++;
            const nonTagChars = html
                .split('')
                .filter((char) => char !== '<' && char !== '>').length;
            const timeout = isTag
                ? 0
                : Math.max(1, Math.floor(ANIMATION_DURATION_MS / nonTagChars));
            setTimeout(type, timeout);
        }
        type();
    }, [html, showAnimation]);
    return (_jsx("span", { className: "markdown text-foreground w-full text-base leading-6 [&_p]:max-w-md", dir: isArabic(text), children: _jsx("div", { className: "animate-fade-in", children: _jsx(Linkify, { children: showAnimation ? displayedText : html }) }) }));
};
